// extracted by mini-css-extract-plugin
export default {"document_content_single":"style_document_content_single__A13Ap"};